<template>
    <div class="main-form">
        <StepNumber
            stepNum="3"
            totalSteps="5"
        ></StepNumber>
        <div class="main-form_info">
            <InputSlider
                :minValue = 0
                :maxValue = 1000000
                :step = 1000
                :currentValue = "$store.state.prescoringData.precio_compra??0"
                :title="$store.state.newTexts.step_datos_hipoteca_2avivienda[0].title"
                @valueChanged = "(value) => handleValueChanged('precio_compra',value)"
            ></InputSlider>
            <InputSelect
                :options="$store.state.inputOptionsVariables.provincias"
                placeholder = "Selecciona provincia"
                :title="$store.state.newTexts.step_datos_hipoteca_2avivienda[1].title"
                :explanation="$store.state.newTexts.step_datos_hipoteca_2avivienda[1].explanation || ''"
                :selected = "$store.state.prescoringData.provincia"
                @valueChanged = "(value) => handleValueChanged('provincia',value)"
            ></InputSelect>
            <InputSlider
                :minValue = 0
                :maxValue = parseInt($store.state.prescoringData.precio_compra)
                :step = 1000
                :currentValue = "$store.state.prescoringData.aportacion??0"
                :title = "$store.state.newTexts.step_datos_hipoteca_2avivienda[2].title"
                :explanation = "$store.state.newTexts.step_datos_hipoteca_2avivienda[2].explanation || ''"
                @valueChanged = "(value) => handleValueChanged('aportacion',value)"
                :mostrarBloque = true
            >
                <div class="bloque_ltv">
                    <div class="contenido_ltv">
                        <span style="font-size: 20px; font-weight: bold; line-height: 35px;">{{$store.state.porcentajeHipoteca}} %</span><span style="font-size: 12px;">LTV</span>
                    </div>
                </div>
            </InputSlider>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputSlider from '../common/InputSlider.vue'
import InputSelect from '../common/InputSelect.vue'

export default {
    name: 'step_datos_hipoteca_2avivienda',
    data: () => {
        return {
            aportacionOptions: null
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    components: {
        StepNumber,
        NavegationButtons,
        InputSlider,
        InputSelect
    },
    computed: {
        nextStep(){
            if(this.$store.state.prescoringData.aportacion == 0){
                this.$store.dispatch('calcularAportaciones2aVivienda');
                return 'step_aval_2avivienda';  
            }
            return 'step_datos_titular';
        },
        canContinue(){
            const { precio_compra, provincia, aportacion } = this.$store.state.prescoringData;
            return precio_compra !== null && precio_compra !== '' && precio_compra > 0 && provincia !== null && provincia !== '' && aportacion !== null && aportacion !== '' ;
        }
    },
    methods: {
        handleValueChanged(field, value){
            this.$store.commit('updatePrescoringData', { field, value });
            if(field === 'precio_compra' && this.$store.state.prescoringData.precio_compra < this.$store.state.prescoringData.aportacion){               
                this.$store.commit('updatePrescoringData', {field: 'aportacion', value: this.$store.state.prescoringData.precio_compra});
            }
            this.$store.dispatch('calcularPorcentaje');
        }
    }
}
</script>


<style scoped>
    .bloque_ltv{
        display: block;
        margin: 30px 0 0 10px;
    }
    .contenido_ltv{
        background-color: #f6f6f6; 
        color: #8f8f8f;
        width: 85px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border-radius: var(--border-radius);
        padding: 11px 0;
    }
    @media (max-width: 768px) {
        .contenido_ltv {
            padding: 20px 0;
        }
    }
</style>
